import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordField({ id, label, value, onChange, testid, autoComplete = "current-password", hint }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-xs font-semibold uppercase tracking-[0.2em] text-ink-muted mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          type={show ? "text" : "password"}
          className="input-field !pr-12"
          required
          minLength={8}
          value={value}
          onChange={onChange}
          data-testid={testid}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="absolute right-3.5 top-1/2 -translate-y-1/2 text-ink-muted hover:text-pine transition-colors"
          aria-label={show ? "Nascondi password" : "Mostra password"}
          data-testid={`${testid}-toggle`}
        >
          {show ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {hint && <p className="mt-2 text-xs text-ink-muted">{hint}</p>}
    </div>
  );
}
